(function () {

    var container = document.getElementById('scrollama-container-h0bz8mmgu');
    if (!container) return;

    var steps = container.querySelectorAll('#scrollama-steps-h0bz8mmgu .slide');
    var menuItems = container.querySelectorAll('.menu ul li');
    var centers = container.querySelectorAll('.list .center');
    var wave = container.querySelector('.banga');
    var waveSVG = wave.querySelector("svg path");

    var menu_ul = container.querySelector('.menu ul');

    // IMPORTANT: separate slide count and center count
    const LAST_SLIDE = steps.length - 1;       // = 3
    const LAST_CENTER = centers.length - 1;     // = 2


    let lastResetScrollY = 0;
    let lastScrollY = window.scrollY;
    let maxGrow = 1000;          // slower scale
    let maxScaleY = 1;
    let isSectionVisible = false;


    const bgColors = ["#fe785d", "#745aff", "#745aff"];

    /** detect slider visibility */
    var sectionObserver = new IntersectionObserver(function (entries) {
        entries.forEach(entry => {
            isSectionVisible = entry.isIntersecting;
        });
    }, {threshold: 0, rootMargin: "500px 0px 0px 0px"});

    sectionObserver.observe(container);

    function getCenterIndexFromSlide(slideIndex) {
        if (slideIndex >= LAST_CENTER) {
            return LAST_CENTER; // slide 2 & 3 -> center 2
        }
        return slideIndex;
    }


    /** MAIN SCROLL ANIMATION */
    function updateWaveScale() {
        if (!isSectionVisible) return;

        let direction = (window.scrollY > lastScrollY) ? "down" : "up";
        lastScrollY = window.scrollY;

        let delta = window.scrollY - lastResetScrollY;


        // SPECIAL LOGIC FOR SLIDE 3 (NOT center 2!)
        if (currentSlide === LAST_SLIDE) {

            centers[LAST_CENTER].classList.add("last");

            jQuery('.menu').addClass('hidden');
            jQuery('.list .center .texts').addClass('hidden');

            wave.style.transform = `translate3d(0,0,0) scale(1,0)`;
            wave.dataset.currScale = 1;
            return;
        } else {
            centers[LAST_CENTER].classList.remove("last");
            jQuery('.menu').removeClass('hidden');
            jQuery('.list .center .texts').removeClass('hidden');
        }

        // NORMAL wave scaling
        let startOffset = 300;

        if (delta < startOffset) {
            wave.style.transform = `translate3d(0,0,0) scale(1, 0)`;
            wave.dataset.currScale = 0;
            return;
        }

        let adjDelta = delta - startOffset;

        adjDelta = Math.max(0, Math.min(adjDelta, maxGrow));

        let progress = adjDelta / maxGrow;

        wave.style.transform =
            `translate3d(0,0,0) scale(1, ${progress})`;

        wave.dataset.currScale = progress;


    }


    window.addEventListener("scroll", updateWaveScale);


    /** helper — detect current active slide */
    function getActiveSlideIndex() {
        let active = 0;
        centers.forEach((c, i) => {
            if (c.classList.contains("active")) active = i;
        });
        return active;
    }


    /** SET ACTIVE SLIDE */
    function setActive(slideIndex) {

        // Convert slide → center (3 → 2)
        let centerIndex = (slideIndex === LAST_SLIDE) ? LAST_CENTER : slideIndex;

        lastResetScrollY = window.scrollY;
        lastScrollY = window.scrollY;

        wave.style.transform = "translate3d(0,0,0) scale(1,0)";
        wave.dataset.currScale = 0;

        let color = bgColors[centerIndex] || bgColors[0];
        wave.style.backgroundColor = color;
        if (waveSVG) waveSVG.style.fill = color;

        // highlight menu item 0,1,2
        menuItems.forEach((li, i) =>
            li.classList.toggle('active', i === centerIndex)
        );

        // highlight centers 0,1,2
        centers.forEach((c, i) => {
            c.classList.toggle('active', i === centerIndex);
            if (i !== LAST_CENTER) c.classList.remove("last");
        });

        // save REAL slide index
        currentSlide = slideIndex;
        currentCenter = centerIndex;
        console.log(currentSlide);
    }


    /** OBSERVE SLIDES */
    var observer = new IntersectionObserver(function (entries) {
        entries.forEach(entry => {
            if (!entry.isIntersecting) return;

            // REAL slide index (0,1,2,3)
            let slideIndex = parseInt(entry.target.dataset.scrollamaIndex, 10);

            // do NOT remap here!
            setActive(slideIndex);
        });
    }, {threshold: 0.5});

    steps.forEach(step => observer.observe(step));


    /** MENU CLICK */
    menuItems.forEach((li, index) => {
        li.addEventListener('click', function (e) {
            e.preventDefault();

            // menu index never goes to slide 3
            steps[index].scrollIntoView({behavior: "smooth"});

            setActive(index);
        });
    });

})();

// NEW ANIMATION


(function () {
    var container = document.getElementById('scrollama-container-d7c4sayh7');
    if (!container) return;

    var step = container.querySelector('.planetac');
    var planeta = container.querySelector('.img.planeta');
    if (!step || !planeta) return;

    function clamp(v, min, max) {
        return v < min ? min : v > max ? max : v;
    }

    function onScroll() {
        var rect = step.getBoundingClientRect();
        var vh = window.innerHeight;

        var rawProgress = 1 - (rect.bottom / (rect.height + vh));

        // ⭐ Faster by multiplying progress
        var progress = clamp(rawProgress * 2.0, 0, 1);

        var minScale = 0.16;
        var maxScale = 1;

        var scale = minScale + (maxScale - minScale) * progress;

        planeta.style.transform = 'scale(' + scale + ')';
    }

    window.addEventListener('scroll', onScroll);
    window.addEventListener('resize', onScroll);
    onScroll();
})();


(function () {
    var container = document.getElementById('scrollama-container-08ra84gau');
    if (!container) return;

    var rocket = container.querySelector('.rocket');
    var img = container.querySelector('.img');
    var bg = container.querySelector('.fixed');
    var step = container.querySelector('#scrollama-steps-08ra84gau .page');
    if (!step) return;

    let isVisible = false;

    // Detect visibility of section
    var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            isVisible = entry.isIntersecting;
            if (!isVisible) {
                rocket.style.transform = '';
                jQuery(bg).hide();
                img.classList.remove('active');

            } else {
                jQuery(bg).show();
                img.classList.add('active');
            }
        });
    }, {threshold: 0.1});

    obs.observe(step);

    // Scroll-based animation
    function updateRocket() {
        if (!isVisible) return;

        let rect = step.getBoundingClientRect();
        let h = window.innerHeight;

        // Progress from 0 → 1
        let progress = 1 - (rect.top / h);
        progress = Math.max(0, Math.min(1, progress));

        // FULL 100% upward movement
        let translateY = -(progress * 100);

        rocket.style.transform = `translate3d(0, ${translateY}%, 0)`;
    }

    window.addEventListener('scroll', updateRocket);
    window.addEventListener('resize', updateRocket);
})();

(function () {

    let container = document.getElementById('scrollama-container-3fe1eyu4y');
    let step      = container?.querySelector('#scrollama-steps-3fe1eyu4y .page');
    let banga     = container?.querySelector('.banga');

    if (!container || !step || !banga) return;

    // CONFIG
    let startOffset   = 1800;   // downward delay
    let maxGrow       = 2000;   // grow time
    let reverseOffset = 800;    // upward buffer

    // STATE
    let sectionTopPage = null;   // absolute page Y of section top
    let sectionVisible = false;
    let lastScrollY    = window.scrollY;


    function update() {

        let rect = step.getBoundingClientRect();
        let vh   = window.innerHeight;

        let scrollY    = window.scrollY;
        let scrollDiff = scrollY - lastScrollY;   // +down / -up
        let scrollingDown = scrollDiff > 0;
        lastScrollY = scrollY;

        let visibleNow = rect.top < vh && rect.bottom > 0;

        // ----------------------------------------
        // ENTERING VIEWPORT
        // ----------------------------------------
        if (visibleNow && !sectionVisible) {

            sectionVisible = true;
            container.classList.add("active");

            // anchor at the TOP of the section
            sectionTopPage = scrollY + rect.top;

            if (scrollingDown) {
                // entering from above → reset delta to 0
                sectionTopPage = scrollY;
            }
        }

        // ----------------------------------------
        // EXITING: remove active only when section
        // is completely BELOW viewport while scrolling UP
        // ----------------------------------------
        if (!scrollingDown) {
            if (rect.top >= vh) {
                sectionVisible = false;
                container.classList.remove("active");
            }
        }

        // STOP if we have never anchored
        if (sectionTopPage === null) return;

        // ----------------------------------------
        // REAL DELTA based on section position
        // ----------------------------------------
        let delta = scrollY - sectionTopPage;
        delta = Math.max(0, delta);

        let maxTotal = startOffset + maxGrow;
        delta = Math.min(delta, maxTotal);

        // =====================================================================
        // DOWNWARD ANIMATION
        // =====================================================================
        if (scrollingDown) {

            if (delta < startOffset) {
                banga.style.transform = "translate3d(0,0,0) scale(1,0)";
                return;
            }

            let adj = delta - startOffset;
            let p   = Math.min(adj / maxGrow, 1);

            banga.style.transform = `translate3d(0,0,0) scale(1,${p})`;
            return;
        }

        // =====================================================================
        // UPWARD ANIMATION (NEVER depends on visibility!)
        // =====================================================================
        if (!scrollingDown) {

            // 1. FULL LOCK (within reverse offset)
            if (delta > startOffset + reverseOffset) {
                banga.style.transform = "translate3d(0,0,0) scale(1,1)";
                return;
            }

            // 2. CLOSED before startOffset
            if (delta <= startOffset) {
                banga.style.transform = "translate3d(0,0,0) scale(1,0)";
                return;
            }

            // 3. SHRINKING zone
            let adj = delta - startOffset;
            let p   = Math.max(0, Math.min(adj / maxGrow, 1));

            banga.style.transform = `translate3d(0,0,0) scale(1,${p})`;
        }
    }

    window.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
    update();

})();




(function () {

    let container = document.getElementById('scrollama-container-83q4g5ysf');
    if (!container) return;

    let step = container.querySelector('#scrollama-steps-83q4g5ysf .page');
    let zeme = container.querySelector('.zeme');
    let rocket = container.querySelector('.rocket');

    if (!step || !zeme || !rocket) return;

    let sectionVisible = false;
    let delta = 0;
    let lastScrollY = window.scrollY;

    // ZEME CONFIG
    let zemeTranslateEnd = 800;
    let zemeScaleMax = 5;
    let zemeScaleDiv = 100;   // Smaller = faster scale

    // ROCKET CONFIG
    let rocketRotateEnd = 180;
    let rocketMoveEndY = 1000;

    // ⭐ SLOW ROTATION
    let rotationSpeed = 6; // increase to slow more (6 recommended)

    // ACTIVE CLASS OFFSET
    let activeOffsetRatio = 0.90;
    let activeOffsetPx = window.innerHeight * activeOffsetRatio;

    function update() {

        let rect = step.getBoundingClientRect();
        let viewportHeight = window.innerHeight;

        activeOffsetPx = viewportHeight * activeOffsetRatio;

        // Offset-based visibility
        let isVisible =
            rect.top < viewportHeight - activeOffsetPx &&
            rect.bottom > activeOffsetPx;

        let currentY = window.scrollY;
        let diff = currentY - lastScrollY;
        lastScrollY = currentY;

        let scrollDown = diff > 0;

        // ------------------------------------------------
        // ACTIVE CLASS HANDLING
        // ------------------------------------------------
        if (isVisible && !sectionVisible) {
            sectionVisible = true;
            container.classList.add("active");
            if (scrollDown) delta = 0;
        }

        // Only remove active when scrolling upward and section is fully above viewport
        if (!isVisible && sectionVisible && !scrollDown && rect.bottom <= 0) {
            sectionVisible = false;
            container.classList.remove("active");
        }

        if (!isVisible) return;

        // ACCUMULATE DELTA
        delta += diff;
        delta = Math.max(0, delta);

        // ------------------------------------------------
        // ZEME (planet)
        // ------------------------------------------------
        if (delta < zemeTranslateEnd) {

            let translate = -delta;
            if (translate < -zemeTranslateEnd)
                translate = -zemeTranslateEnd;

            zeme.style.transform =
                `translate3d(0, ${translate}px, 0) scale(1,1)`;

        } else {

            let scaleDelta = delta - zemeTranslateEnd;
            let scale = 1 + (scaleDelta / zemeScaleDiv);

            if (scale > zemeScaleMax)
                scale = zemeScaleMax;

            zeme.style.transform =
                `translate3d(0, -${zemeTranslateEnd}px, 0) scale(${scale},${scale})`;
        }

        // ------------------------------------------------
        // ROCKET — slow rotation, then move
        // ------------------------------------------------
        if (delta < rocketRotateEnd * rotationSpeed) {

            let rot = -(delta / rotationSpeed);

            if (rot < -rocketRotateEnd)
                rot = -rocketRotateEnd;

            rocket.style.transform =
                `translate3d(0,0,0) rotate(${rot}deg)`;

        } else {

            let moveDelta = (delta - rocketRotateEnd * rotationSpeed);
            let t = moveDelta / rocketMoveEndY;   // normalize 0 → 1
            t = Math.min(t, 1);

            // Cubic ease-out (fast at the start → slow at the end)
            let eased = 1 - Math.pow(1 - t, 3);

            let moveY = eased * rocketMoveEndY;

            rocket.style.transform =
                `translate3d(0, ${moveY}px, 0) rotate(-180deg)`;
        }

    }

    window.addEventListener("scroll", update);
    window.addEventListener("resize", update);
    update();

})();







